const config = {
  baseURL: process.env.REACT_APP_BACKEND_URL || 'https://api.fina-ai.org'
};
export default config;

